module.exports = __webpack_public_path__ + "fonts/BebasNeueThin.298c4b72.ttf";